import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/lp/samla-lan")({
  beforeLoad: () => {
    throw redirect({ to: "/lp/samling-lan" });
  },
});
